import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import CouponForm from '../CouponForm';
import PrintCoupon from '../PrintCoupon';

const propTypes = {
  coupon: PropTypes.shape({
    style: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  headerLogoUrl: PropTypes.string,
  headerLogoMediumId: PropTypes.string,
  facilityId: PropTypes.string.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  requested: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  showCoupon: PropTypes.bool,
};

const defaultProps = {
  coupon: undefined,
  headerLogoUrl: undefined,
  headerLogoMediumId: undefined,
  onClose: undefined,
  errorMessage: undefined,
  showCoupon: undefined,
};

const CouponModal = ({
  coupon,
  headerLogoUrl,
  headerLogoMediumId,
  facilityId,
  isRequesting,
  onClose,
  onSubmit,
  onSubmitSuccess,
  requested,
  errorMessage,
  showCoupon,
}) => {
  let content = null;

  if (requested) {
    content = (
      <PrintCoupon
        coupon={coupon}
        facilityId={facilityId}
        onClose={onClose}
        headerLogoUrl={headerLogoUrl}
        headerLogoMediumId={headerLogoMediumId}
      />
    );
  } else {
    content = (
      <CouponForm
        coupon={coupon}
        facilityId={facilityId}
        isRequesting={isRequesting}
        onClose={onClose}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        requested={requested}
        errorMessage={errorMessage}
      />
    );
  }

  return (
    <Modal show={showCoupon} keyboard onHide={onClose}>
      {content}
    </Modal>
  );
};

CouponModal.propTypes = propTypes;

CouponModal.defaultProps = defaultProps;

export default CouponModal;
